import { Hits, Relation } from "../../../types/Paginated";

type LabelDisplayedRowsArgs = {
  from: number;
  to: number;
  page: number;
};

export const formatPaginationLabel = (
  count: Hits,
  { from, to }: LabelDisplayedRowsArgs,
): string => {
  const totalCountText =
    count.relation === Relation.GTE ? `${count.value}+` : `${count.value}`;
  return `${from}–${to} of ${totalCountText}`;
};
